import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20background%20with%20soft%20caramel%20and%20cream%20gradient%20flowing%20smoothly%2C%20subtle%20comic%20panel%20line%20art%20elements%20floating%20organically%2C%20minimalist%20Korean%20manhwa%20aesthetic%20with%20gentle%20curves%2C%20warm%20ambient%20golden%20glow%20radiating%20from%20center%2C%20clean%20dreamy%20atmosphere%20with%20soft%20color%20transitions%2C%20no%20text%20no%20letters%2C%20soft%20focus%20edges%2C%20gentle%20bokeh%20light%20particles%2C%20artistic%20digital%20illustration%20style%2C%20golden%20hour%20warm%20lighting%2C%20ethereal%20and%20cozy%20mood%2C%20organic%20flowing%20shapes&width=1600&height=900&seq=pudding-hero-01&orientation=landscape"
          alt="布丁漫画 - 下拉式漫画阅读平台"
          title="布丁漫画下拉式看漫画免费 | 下拉式全集韩漫国漫在线追更"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/45 via-foreground-950/25 to-background-50" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sparkling-line text-sm text-accent-400"></i>
            </span>
            <span className="text-xs text-background-50/90 font-medium">全新下拉式阅读体验</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            下拉式看漫画
            <br />
            <span className="text-primary-400">一气呵成不卡顿</span>
          </h1>
          <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-8 leading-relaxed">
            布丁漫画下拉式阅读专区，提供流畅的下拉式漫画观看体验，免费看韩漫、国漫、日漫全集，支持在线追更，阅读不卡顿一气呵成。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/hanman"
              className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              立即开始阅读
              <span className="w-4 h-4 inline-flex items-center justify-center ml-1">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 text-sm font-medium rounded-full border border-background-50/25 hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
          <div className="flex items-center justify-center gap-8 mt-10">
            {[
              { value: '3,000+', label: '漫画资源' },
              { value: '500万+', label: '月活用户' },
              { value: '50亿+', label: '累计阅读' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-background-50">{stat.value}</div>
                <div className="text-xs text-background-50/60 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-line text-background-50/50 text-xl"></i>
        </span>
      </div>
    </section>
  );
}